import App from './App.vue';
import router from './router';
import './assets/styles/main.scss';
import i18n from '@/shared/plugins/i18n';
import { initApp } from '@/shared/main';
import { configEnv } from '@/shared/config-env';
import { useUiStore } from '@/shared/store/useUiStore';

initApp(App, router, i18n, configEnv.PEOPLE_CLIENT_ID).then((store: any) => {
  const ui = useUiStore();
  ui.setHeaderClasses('burger-right');
});
